export const ADMIN_NAV_ITEMS = [
  { path: '/admin/client-workflow-templates', display: 'Manage Client Workflow Templates' } 
  , { path: '/admin/tags', display: 'Tags' } 
  , { path: '/admin/clients', display: 'All Clients' } 
  , { path: '/admin/staff', display: 'All Staff' } 
  // , { path: '/admin/client-workflows', display: 'All Client Workflows' } 
  , { path: '/admin/quick-tasks', display: 'All Quick Tasks' } 
  , { path: '/admin/share-links', display: 'ShareLinks' } 
];
